import addBuildingUrls from "../api/urls";

export const getUploadDestPath = ({
  datetime,
  fileSection,
  fileType,
  userId,
}: {
  datetime: Date;
  fileSection?: string;
  fileType: "file" | "image";
  userId: string;
}) => {
  const basePath = addBuildingUrls.uploadRootDestPath();
  const datePart = datetime.toISOString().replace(/-/g, "").replace(/:/g, "").replace(/T/g, "").split(".")[0];
  const fileTypePart = fileType === "file" ? `${fileType}/${fileSection}` : fileType;
  return `${basePath}/${userId}/${datePart}/${fileTypePart}`;
};
